import React from 'react';
import MediumPriorityFeatures from '../components/QRBILLING/MediumPriorityFeatures';

const TestMediumFeatures = () => {
  const [showModal, setShowModal] = React.useState(true);

  return (
    <div style={{ padding: '20px' }}>
      <h1>Medium Priority Features Test Page</h1>
      
      <button
        onClick={() => setShowModal(true)}
        style={{
          background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
          color: 'white',
          border: 'none',
          padding: '12px 24px',
          borderRadius: '8px',
          fontWeight: '600',
          fontSize: '1rem',
          cursor: 'pointer'
        }}
      >
         Open Medium Features
      </button>

      {showModal && (
        <MediumPriorityFeatures
          recipeId={1}
          menuItemId={1}
          businessId={1}
          onClose={() => setShowModal(false)}
        />
      )}
    </div>
  );
};

export default TestMediumFeatures;
